import { Head, Link } from '@inertiajs/react'
import { PageProps } from '@/types'

export default function NotFound(_props: PageProps) {
  return (
    <>
      <Head title="Page not found" />
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background text-center">
        <p className="text-5xl font-bold text-foreground">404</p>
        <p className="text-lg text-muted-foreground">Page not found</p>
        <Link href="/" className="text-sm text-primary hover:underline">
          Go home
        </Link>
      </div>
    </>
  )
}
